/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, startTime: NonNullable<unknown>, endTime: NonNullable<unknown> }} Booking_Confirmation_Mail_FailedInputs */

const en_booking_confirmation_mail_failed = /** @type {(inputs: Booking_Confirmation_Mail_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your appointment is confirmed. However, the confirmation email could not be sent — please make a note of the appointment; you can also find it in your profile. Appointment: ${i?.date}, ${i?.startTime}–${i?.endTime}.`)
};

const de_booking_confirmation_mail_failed = /** @type {(inputs: Booking_Confirmation_Mail_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dein Termin ist verbindlich gebucht. Die Bestätigungs-E-Mail konnte jedoch nicht versendet werden — bitte notiere dir den Termin; du findest ihn auch in deinem Profil. Termin: ${i?.date}, ${i?.startTime}–${i?.endTime} Uhr.`)
};

/**
* | output |
* | --- |
* | "Your appointment is confirmed. However, the confirmation email could not be sent — please make a note of the appointment; you can also find it in your profil..." |
*
* @param {Booking_Confirmation_Mail_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const booking_confirmation_mail_failed = /** @type {((inputs: Booking_Confirmation_Mail_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Confirmation_Mail_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_booking_confirmation_mail_failed(inputs)
	return en_booking_confirmation_mail_failed(inputs)
});